//import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from "react-redux";

import { store, persistor } from './Store';


import "./i18n";
import App from './App';
import reportWebVitals from './reportWebVitals';

// get element by id
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// if id is found then render app on that element
root.render(
  <>
    {/* <StrictMode> */}
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
    {/* </StrictMode>  */}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
